import React, { type ReactNode } from "react";
import { Text, Flex, Box, Spinner, type FlexProps, type IconProps } from "@chakra-ui/react";
import {
  FacebookIcon,
  FacebookMonoIcon,
  GoogleAdsIcon,
  GoogleAdsMonoIcon,
  TikTokIcon,
  TikTokMonoIcon,
} from "ui/icons/integrations";
import { CheckIcon } from "ui/icons";

function Heading({ children }: { children: ReactNode }) {
  return (
    <Text
      flex={1}
      fontSize={{ base: "11px", lg: "xs" }}
      fontWeight="semibold"
      letterSpacing="0.36px"
      textTransform="uppercase"
    >
      {children}
    </Text>
  );
}

function Row({ children }: { children: ReactNode }) {
  return (
    <Flex align="center" gap={2}>
      {children}
    </Flex>
  );
}

function IconRow({
  text,
  iconMono,
  iconColor,
}: {
  text: string;
  iconMono: (props: IconProps) => JSX.Element;
  iconColor: (props: IconProps) => JSX.Element;
}) {
  return (
    <Row>
      <Box boxSize={{ base: 4, lg: 5 }} pos="relative">
        <Box as={iconMono} pos="absolute" inset={0} boxSize="100%" />
        <Box as={iconColor} pos="absolute" inset={0} boxSize="100%" opacity={0} />
      </Box>

      <Text flex={1} fontSize={{ base: "10px", lg: "13px" }} lineHeight={{ base: "16px", lg: "20px" }}>
        {text}
      </Text>
    </Row>
  );
}

export function DestinationMenu(props: FlexProps) {
  return (
    <Flex
      bg="white"
      border="1px"
      borderColor="base.border"
      borderRadius="md"
      boxShadow="md"
      direction="column"
      fontFamily="inter"
      gap={{ base: 4, lg: 5, xl: 6 }}
      p={3.5}
      w={{ base: "200px", lg: "220px", xl: "255px" }}
      {...props}
    >
      <Row>
        <Heading>Sync audience</Heading>
        <Box boxSize={{ base: 4, lg: 5 }} pos="relative">
          <Spinner
            id="funnels-menu-spinner"
            size="sm"
            color="product.forest.600"
            emptyColor="product.gray.100"
            pos="absolute"
            top={0}
            right={0}
            bottom={0}
            opacity={0}
          />

          <CheckIcon
            id="funnels-check-svg"
            boxSize={{ base: 4, lg: 5 }}
            color="grass"
            pos="absolute"
            top={0}
            right={0}
            bottom={0}
            opacity={0}
          />
        </Box>
      </Row>

      <IconRow
        iconMono={(props: IconProps) => <FacebookMonoIcon id="funnels-fb--mono" {...props} />}
        iconColor={(props: IconProps) => <FacebookIcon id="funnels-fb--color" {...props} />}
        text="Facebook"
      />

      <IconRow
        iconMono={(props: IconProps) => <GoogleAdsMonoIcon id="funnels-ga--mono" {...props} />}
        iconColor={(props: IconProps) => <GoogleAdsIcon id="funnels-ga--color" {...props} />}
        text="Google Ads"
      />

      <IconRow
        iconMono={(props: IconProps) => <TikTokMonoIcon id="funnels-tiktok--mono" {...props} />}
        iconColor={(props: IconProps) => <TikTokIcon id="funnels-tiktok--color" {...props} />}
        text="TikTok"
      />
    </Flex>
  );
}
